/**
 * Texto e formatação compartilhados entre telas de agentes / execuções.
 */
export function useAgentUi() {
  function agentNameInitials(name) {
    if (!name || !String(name).trim()) return '?'
    const p = String(name).trim().split(/\s+/)
    if (p.length >= 2) return `${p[0][0]}${p[1][0]}`.toUpperCase()
    return String(name).slice(0, 2).toUpperCase()
  }

  function runStatusLabel(status) {
    const m = {
      queued: 'Na fila',
      running: 'Em execução',
      succeeded: 'Concluída',
      failed: 'Falhou',
      cancelled: 'Cancelada'
    }
    return m[status] || status
  }

  function runStatusClass(status) {
    if (status === 'running') return 'text-green-700 font-medium'
    if (status === 'queued') return 'text-amber-700 font-medium'
    if (status === 'succeeded') return 'text-green-700'
    if (status === 'failed') return 'text-red-700'
    return 'text-gray-600'
  }

  function formatIsoTime(iso) {
    if (!iso) return '—'
    try {
      return new Date(iso).toLocaleString()
    } catch {
      return iso
    }
  }

  /** Data/hora sem ano (cards estreitos) — ex.: 21/03, 14:53:00 */
  function formatIsoTimeCompact(iso) {
    if (!iso) return '—'
    try {
      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).format(new Date(iso))
    } catch {
      return iso
    }
  }

  function jsonPreview(obj) {
    if (obj == null) return '—'
    try {
      return JSON.stringify(obj)
    } catch {
      return String(obj)
    }
  }

  return {
    agentNameInitials,
    runStatusLabel,
    runStatusClass,
    formatIsoTime,
    formatIsoTimeCompact,
    jsonPreview
  }
}
